import { APP_INITIALIZER, ErrorHandler, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AuthModule } from 'angular-auth-oidc-client';

import { MomentModule } from 'ngx-moment';
import { NgPipesModule } from 'ngx-pipes';
import { environment } from '../environments/environment';
import { AppComponent } from './app.component';
import { FooterComponent } from './footer/footer.component';
import { HeaderComponent } from './header/header.component';
import { ShowNewsComponent } from './show-news/show-news.component';
import { StartComponent } from './start/start.component';
import { AppRoutingModule } from './app-routing.module';
import { UnauthorizedComponent } from './unauthorized/unauthorized.component';
import { FormsModule } from '@angular/forms';
import { ShowFaqComponent } from './show-faq/show-faq.component';
import { NgbModule, NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { ShowSurveyComponent } from './show-survey/show-survey.component';
import { LaunchTogetherComponent } from './launch-together/launch-together.component';
import { SafeHtmlPipe } from './show-news/safe-html.pipe';


@NgModule({
  bootstrap: [AppComponent],
  exports: [
    SafeHtmlPipe,
  ],
  declarations: [
    AppComponent,
    FooterComponent,
    HeaderComponent,
    ShowNewsComponent,
    ShowFaqComponent,
    StartComponent,
    UnauthorizedComponent,
    ShowSurveyComponent,
    LaunchTogetherComponent,
    SafeHtmlPipe
  ],
  imports: [
    BrowserModule,
    AuthModule.forRoot({
      config: environment.openIdConfig
    }),
    AppRoutingModule,
    MomentModule,
    NgPipesModule,
    FormsModule,
    NgbTooltipModule,
    NgbModule,
  ],
})
export class AppModule { }
